import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser,faCircleUser } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next';
import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Menu, Space } from 'antd';
import getOrgById from '../../hooks/getOrgById';
import { useState } from 'react';

export const OrgNav = () => {
  const { t } = useTranslation(['common']);
  const [isAdmin,setisAdmin] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user'));
  const orgResp=getOrgById(user.organizationId)
  console.log(orgResp)
  const org=orgResp.response?orgResp.response.data:"";
  console.log(org);
  localStorage.setItem('userId', JSON.stringify(user.userId));
  if(user.userType==="A")setisAdmin(true);
  console.log(isAdmin);
  console.log(user.userId)
  const logOutHandler = () => {
    let keysToRemove = ["user", "admAdId","getUserId","eventId","bannerId","productCatId","orgAdId","causeId","causeCategoryId","kioskId",
    "ethnicId","userId","donorIdforRecurring","donorId","merchantId"];
      for (let key of keysToRemove) {
        localStorage.removeItem(key);
      }
    isAdmin?navigate('/adminlogin'):navigate('/');
    window.location.reload();
  };
  const items = [
    {
      label: (
        <a rel='noopener noreferrer' href={`/orguserprofile/edit`}>
        Profile  
        {/* <hr/> */}
        </a>

      ),
      key: '0',
    },
    // {
    //   label: (
    //    <hr />
    //   ),
    //   key: '1',
    // },
    {
      label: (
        <a target='_blank' onClick={logOutHandler}>
         Sign Out
        </a>
      ),
      key: '1',
    },
  ]

  return (
    <nav class="app-navbar">
    <a > <div>
           <img src='/logo.png' style={{ height: '54px'}} alt='Logo Image' />
         </div></a>
    <a style={{display:"inherit"}}><span className='bg-white'> <img src={`${org?org.organizationLogo:" "}`} style={{font:"white", height: '57px' }} alt='Logo Image' /></span><span class='fs-3 mt-2 ml-2 text-white' > {org?org.organizationName:" "} </span></a>
    <div style={{display:"inherit"}}> <div class='fw-bold mt-3 mr-3 text-white'>
           {t('Hi')} {user ? user.name : ' '} {' '}
         </div>
         <Dropdown className="mt-2 mr-2 pl-1 w-30 text-white"
           menu={{
             items,
           }}
         >
           <a onClick={(e) => e.preventDefault()}>
             <Space>
             <FontAwesomeIcon   className='mr-2 mt-1 text-white fa-2xl' icon={faCircleUser} />
               <DownOutlined className='fa-sm'/>
             </Space>
           </a>
         </Dropdown>
       </div>
  
    {/* <form class="form-inline">
      <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search"/>
      <button class="btn btn-outline-success my-2 my-sm-0" type="submit">Search</button>
    </form> */}
  </nav>
  );
};
export default OrgNav;
